import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import CourseImage from "./CourseImageUpload";
import CourseVideo from "./CourseVideoUpload";
import CourseFile from "./CourseFileUpload";
import { useLocation } from "react-router-dom";
import { Loading } from "@/pages/Other/Loading";
const _ = require("lodash");
function CreateCourse(props) {
  const location = useLocation();
  const { user } = useSelector((state) => state.users);
  const [courseState, SetCourseState] = useState({
    id: location.state ? location.state.ID : "",
    courseName: location.state ? location.state.CourseName : "",
    description: location.state ? location.state.Description : "",
    subCategory: location.state ? location.state.SubCategory : "",
    Category: location.state ? location.state.Category : "",
    duration: location.state ? location.state.Duration : "",
    enrollmentFee: location.state
      ? location.state.EnrollmentFee
      : "",
    instructorName: location.state
      ? location.state.InstructorsName
      : "",
    language: location.state ? location.state.Language : "",
    level: location.state ? location.state.Level : "",
    requirements: location.state ? location.state.Requirements : "",
    status: location.state ? location.state.Status : "",
    faq: location.state ? location.state.FAQ : "",
    subject: location.state ? location.state.Subject : "",
    summary: location.state ? location.state.Summary : "",
    syllabus: location.state ? location.state.Syllabus : "",
    tags: location.state ? location.state.Tags : "",
  });
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState(null);
  const [courseImage, setcourseImage] = useState([]);
  const [courseVideo, setcourseVideo] = useState([]);
  const [checkAccess, setCheckAccess] = useState(
    localStorage.getItem("askedQues") ? true : false
  );
  const courseImageFile = (content) => {
    if (content.length > 0) readImageFile(content);
  };
  const handleCourseStateChange = (e) => {
    const { name, value } = e.target;
    SetCourseState({
      ...courseState,
      [name]: value,
    });
  };
  const courseVideoFile = (content) => {
    let temp = [];
    if (content != "" && content != null && typeof content == "object") {
      content.forEach((element, index) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          const Testing = element.name;
          const extension = Testing.split(".").pop();
          const Filename = Testing.split(".").slice(0, -1).join(".");
          temp.push({
            fileNumber: index + 1,
            base64: reader.result,
            fileName: Filename,
            fileExt: extension,
            fileSize: element.size,
          });
        };
        reader.readAsDataURL(element);
      });
      setcourseVideo(temp);
    }
  };
  const readImageFile = (file) => {
    let temp = [];
    file.forEach((element, index) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const Testing = element.name;
        const extension = Testing.split(".").pop();
        const Filename = Testing.split(".").slice(0, -1).join(".");
        temp.push({
          fileNumber: index + 1,
          base64: reader.result,
          fileName: Filename,
          fileExt: extension,
          fileSize: element.size,
        });
        setcourseImage(temp);
      };
      reader.readAsDataURL(element);
    });
  };
  const handleSubmit = async () => {
    setLoading(true);
    setIsError(false);

    const sentObject = {
      ...courseState,
      imageFiles: courseImage,
      videoFiles: courseVideo,
      userId: user.id,
    };

    const sentObjectSanitized = _.omit(sentObject, ["id"]);

    try {
      let res;

      if (!courseState.id) {
        res = await axios.post("course/", JSON.stringify(sentObjectSanitized), {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } else {
        res = await axios.put(
          "course/" + courseState.id,
          JSON.stringify(sentObjectSanitized),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      stateToEmpty(res);
    } catch (error) {
      console.error("Error submitting course:", error.message);
      stateToEmpty("", "error");
    }

    function stateToEmpty(res = "", error = "") {
      if (!error) {
        setData(res.data);
        setLoading(false);
      } else {
        setLoading(false);
        setIsError(true);
      }
    }
  };

  return (
    <>
      <div>
        <div className="createcourse">
          <div className="page-title">Create your Course</div>
          <div className="form-flex-wrap">
            <label htmlFor="courseName">Course Title</label>
            <input
              type="text"
              className="form-control"
              id="courseName"
              placeholder="Enter course title"
              name="courseName"
              value={courseState.courseName}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="description" className="mt-2">
              Course Description
            </label>
            <input
              type="text"
              className="form-control"
              id="description"
              name="description"
              placeholder="Enter course description"
              value={courseState.description}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="Category" className="mt-2">
              Category
            </label>
            <select
              aria-label="Category"
              className="select"
              onChange={handleCourseStateChange}
              id="Category"
              name="Category"
              value={courseState.Category}
            >
              <option>Select Category</option>
              <option value="Development">Development</option>
              <option value="Business">Business</option>
              <option value="Finance & Accounting">Finance & Accounting</option>
              <option value="IT & Software">IT & Software</option>
              <option value="Art & Design">Art & Design</option>
              <option value="Sales & Marketing">Sales & Marketing</option>
              <option value="Lifestyle">Lifestyle</option>
              <option value="Video & Photography">Video & Photography</option>
              <option value="Health & Fitness">Health & Fitness</option>
              <option value="Music">Music</option>
              <option value="Academics & Education">
                Academics & Education
              </option>
              <option value="Uncategorized">Uncategorized</option>
            </select>
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="duration">SubCategory</label>
            <input
              type="text"
              className="form-control"
              id="subCategory"
              name="subCategory"
              placeholder="Enter total duration of this course"
              value={courseState.subCategory}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="duration">Total course duration</label>
            <input
              type="text"
              className="form-control"
              id="duration"
              name="duration"
              placeholder="Enter total duration of this course"
              value={courseState.duration}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="enrollmentFee">Course price</label>
            <input
              type="number"
              className="form-control"
              id="enrollmentFee"
              name="enrollmentFee"
              placeholder="Course price"
              value={courseState.enrollmentFee}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="instructorName">Instructor Name</label>
            <input
              type="text"
              className="form-control"
              id="instructorName"
              name="instructorName"
              placeholder="Enter the Instructor name"
              value={courseState.instructorName}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="language">Language(s)</label>
            <input
              type="text"
              className="form-control"
              id="language"
              name="language"
              placeholder="Enter the language for this course"
              value={courseState.language}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="level">Level</label>
            <input
              type="text"
              className="form-control"
              id="level"
              name="level"
              placeholder="Enter the level of the Course "
              value={courseState.level}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="requirements">Requirements</label>
            <input
              type="text"
              className="form-control"
              id="requirements"
              name="requirements"
              placeholder="Enter the Requirements of the course"
              value={courseState.requirements}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="faq">FAQs</label>
            <input
              type="text"
              className="form-control"
              id="faq"
              name="faq"
              placeholder="Enter the FAQ for the Course"
              value={courseState.faq}
              onChange={handleCourseStateChange}
            />
          </div>

          <div className="form-flex-wrap">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              className="form-control"
              id="subject "
              name="subject"
              placeholder="Enter the subject of the course"
              value={courseState.subject}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="summary">Course summary</label>
            <input
              type="text"
              className="form-control"
              id="summary "
              name="summary"
              placeholder="Enter course summary"
              value={courseState.summary}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="syllabus">Syllabus</label>
            <input
              type="text"
              className="form-control"
              id="syllabus"
              name="syllabus"
              placeholder="Enter the syllabus of this course"
              value={courseState.syllabus}
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-flex-wrap">
            <label htmlFor="tags">Tags</label>
            <input
              type="text"
              className="form-control"
              id="tags "
              placeholder="Enter tags of the course, seperated by a comma"
              value={courseState.tags}
              name="tags"
              onChange={handleCourseStateChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="CourseImage" className="mt-2">
              Course Image
            </label>
            <CourseImage
              courseImageFileLimit={1}
              courseImageFile={courseImageFile}
            />
          </div>
          <div className="form-group">
            <label htmlFor="CourseVideo" className="mt-2">
              Course Video
            </label>
            <CourseVideo
              courseVideoFileLimit={1}
              courseImage={courseImage}
              courseVideoFile={courseVideoFile}
            />

            {/* <CourseFile courseFileLimit={1} /> */}
          </div>
          {isError && (
            <small className="mt-3 d-inline-block text-danger">
              Something went wrong. Please try again later.
            </small>
          )}
          <div className="form-flex-wrap">
            <button
              type="submit"
              className="btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? <Loading/> : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export default CreateCourse;
